import { BaseModel } from "../../../ensue-react-system/utilities/base-model";
import { FootballTeam } from "./football-team";
import { IFootballCompetitionTeam } from "./interface/i-football-competition-team";
import { IFootballTeam } from "./interface/i-football-team";

export class FootballCompetitionTeam extends BaseModel implements IFootballCompetitionTeam {
  public id = 0;
  public team: IFootballTeam = new FootballTeam();

  public constructor(props: { [key: string]: any } | undefined = undefined) {
    super(props);
    this.__init(props);
  }
}
